import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  useTheme,
  CardActionArea,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";


function ApplicationCard({
  app,
  onEdit,
  onDelete,
  showDeleteIcon = true,
  showPlusIcon = false,
  showMinusIcon = false,
  onPlusClick,
  onMinusClick,
}) {
  const theme = useTheme();

  return (
    <>
    <Card
      sx={{
        maxWidth: "160px",
        backgroundColor: theme.palette.success.main,
        borderColor: app.defaultApp
          ? theme.palette.primary.main
          : theme.palette.success.text,
        borderWidth: "3px",
        borderStyle: "solid",
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "160px",
        boxShadow: 3,
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          boxShadow: 5,
        },
      }}
    >
      <CardActionArea
        onClick={onEdit}
        sx={{ height: "100%", width: "100%", padding: "8px" }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexGrow={1}
          height="70%"
          padding={1}
        >
          <img
            src={app.icon.startsWith("http") ? app.icon : `/icons/${app.icon}`}
            alt={app.name}
            style={{
              width: "80%",
              height: "80%",
              objectFit: "contain",
            }}
          />
        </Box>
        <CardContent
          sx={{
            padding: "4px 4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.default,
            textAlign: "center",
            height: "30%",
          }}
        >
          <Typography
            variant="body2"
            textAlign="center"
            color={theme.palette.success.text}
            noWrap
          >
            {app.name}
          </Typography>
        </CardContent>
      </CardActionArea>

      {/* Conditional Icons */}
      {showPlusIcon && (
        <IconButton
          onClick={onPlusClick}
          sx={{
            position: "absolute",
            top: 8,
            left: 8, // Left aligned
            color: theme.palette.success.light,
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
        </IconButton>
      )}
      {showMinusIcon && (
        <IconButton
          onClick={onMinusClick}
          sx={{
            position: "absolute",
            top: 8,
            left: showPlusIcon ? 48 : 8, // Adjust left position if both icons are shown
            color: theme.palette.error.main,
          }}
        >
          <FontAwesomeIcon icon={faMinus} />
        </IconButton>
      )}

      {showDeleteIcon && (
        <IconButton
          onClick={onDelete}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: theme.palette.error.main,
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </IconButton>
      )}
    </Card>
    </>
  );
}

export default ApplicationCard;
